module.exports = __webpack_public_path__ + "img/go-website-btn.98e02636.png";